import { AbilityBuilder } from '@casl/ability'

import { UserInfo } from '@/common/hooks/useGetUserInfo'
import { ApplicationAccountUserRole } from '@/common/models/applicationAccountUser'
import { UserType } from '@/common/models/user'
import { AppAbility } from './casl'

type PermissionsByUserType = (
  user: UserInfo,
  builder: AbilityBuilder<AppAbility>,
) => void

export const permissions: Record<UserType, PermissionsByUserType> = {
  OWNER(user, { can, cannot }) {
    can('manage', 'all')
    if (!user.UserPreference.isRoot) cannot('access', 'Settings')
    if (!user.UserPreference.isRoot) cannot('access', 'Applications')

    cannot('inactivate', 'User', { id: user.id })
    cannot('delete', 'User', { id: user.id })
  },
  ADMIN(user, { can, cannot }) {
    can('access', 'Sso')
    can('access', 'Registers')

    can('edit', 'User', { userType: { $ne: UserType.OWNER } })
    can('inactivate', 'User', { userType: { $ne: UserType.OWNER } })
    can('delete', 'User', { userType: { $ne: UserType.OWNER } })
    can('reactivate', 'User', { userType: { $ne: UserType.OWNER } })
    can('create', 'User', { userType: { $ne: UserType.OWNER } })
    cannot('inactivate', 'User', { id: user.id })
    cannot('delete', 'User', { id: user.id })

    can('create', 'ApplicationAccountUser', {
      role: { $ne: ApplicationAccountUserRole.OWNER },
    })
  },
  MEMBERS() {},
}
